import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  @font-face {
      font-family: Baraem;
      font-display:block;
      src: url(/fonts/baraemtv-regular.eot);
      src: url(/fonts/baraemtv-regular.woff) format("woff"),
           url(/fonts/baraemtv-regular.otf) format("opentype"),
           url(/fonts/baraemtv-regular.ttf) format("truetype"),
           url(/fonts/baraemtv-regular.svg) format("svg");
      font-weight: 400;
      font-style: normal
  }
  
  @font-face {
      font-family: BaraemBold;
      font-display:block;
      src: url(/fonts/baraemtv-bold.eot);
      src: url(/fonts/baraemtv-bold.woff) format("woff"),
           url(/fonts/baraemtv-bold.otf) format("opentype"),
           url(/fonts/baraemtv-bold.ttf) format("truetype"),
           url(/fonts/baraemtv-bold.svg) format("svg");
      font-weight: 500;
      font-style: normal
  }
  
  @font-face {
      font-family: WebTv;
      font-display:block;
      src: url(/fonts/webtv-regular.eot);
      src: url(/fonts/webtv-regular.woff) format("woff"),
           url(/fonts/webtv-regular.svg) format("svg");
      font-weight: 400;
      font-style: normal;
  }
  
  @font-face {
      font-family: WebTvBold;
      font-display:block;
      src: url(/fonts/webtv-bold.eot);
      src: url(/fonts/webtv-bold.woff) format("woff"),
           url(/fonts/webtv-bold.svg) format("svg");
      font-weight: 500;
      font-style: normal;
  }
  
  * {
    box-sizing: border-box;
  }
  
  html,
  body,
  #root {
    width: 100%;
    height: 100%;
  }
  
  body {
    font-family: WebTv, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 23px;
  }
  
  a, button {
    cursor: pointer;
  }
  
  a {
    text-decoration: none;
  }
  
  button:focus {
    outline: none;
  }
  
  select:focus {
    outline: none;
  }
  
  h1 {
    font-size: 32px;
    font-family: WebTvBold, Helvetica Neue, Helvetica, Arial, sans-serif;
  }
  
  h2 {
    font-size: 29px;
    font-family: WebTvBold, Helvetica Neue, Helvetica, Arial, sans-serif;
  }
  
  h3 {
    font-size: 28px;
    font-family: WebTvBold, Helvetica Neue, Helvetica, Arial, sans-serif;
  }
  
  input {
    outline: none;
  }
  
  @media (max-width: 979px) {
    body {
      font-size: 16px;
    }
    
    h1 {
      font-size: 26px;
    }
    
    h2 {
      font-size: 23px;
    }
    
     h3 {
      font-size: 22px;
    }
  }
  
  // Animations
  
  
  @keyframes animateShow {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
    
  @keyframes animateShowDown {
    0% {
      opacity: 0;
      transform: translateY(-50%);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes animateShowUp {
    0% {
      opacity: 0;
      transform: translateY(50%);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }   

  @keyframes animateShowLeft {
    0% {
      opacity: 0;
      transform: translateX(50%);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  } 
  
  @keyframes animateShowRight {
    0% {
      opacity: 0;
      transform: translateX(-50%);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }      
`;
